import React, { useContext } from "react";
import { COVERAGE_FORM } from "@platform/rfp-core";

import { RFP_ACTION_TYPES } from "../../constants";
import { RfpContext } from "../../contexts/rfpContext";
import CoverageButtonWrapper from "../components/coverageButtonWrapper";
import CommentsField from "../components/commentsField";

const {
  PLAN_TYPE,
  PLANS,
  ADDITIONAL_NOTES,
  ALTERNATE_PLANS,
  SINGLE_PLAN,
  NO_PLAN,
} = COVERAGE_FORM;
const { UPDATE_SELECTED_COVERAGE } = RFP_ACTION_TYPES;

const initialValues = {
  [ADDITIONAL_NOTES]: "",
  [ALTERNATE_PLANS]: "",
};

export const initialEmployeesCoveragesDetails = {
  [PLAN_TYPE]: SINGLE_PLAN,
  [PLANS]: [
    {
      ...initialValues,
      name: SINGLE_PLAN,
      displayName: NO_PLAN,
    },
  ],
};

const EmployeeAssistanceProgram = ({
  coverage,
  nextCoverage,
  isLastCoverage,
  handleNext,
  handleBack,
  prevCoverage,
  isFirstCoverage,
}) => {
  const { setRfp } = useContext(RfpContext);

  const handleFormChange = (updatedCoverage, currentPlanKey, fieldKey) => {
    setRfp({
      type: UPDATE_SELECTED_COVERAGE,
      value: updatedCoverage,
      currentPlanKey,
      fieldKey,
    });
  };

  return (
    <>
      <EmployeeAssistanceProgramForm
        coverage={coverage}
        onFormChange={handleFormChange}
      />
      <CoverageButtonWrapper
        displayBackButton={!isFirstCoverage}
        displayNextButton={!isLastCoverage}
        backButtonName={prevCoverage?.name}
        nextButtonName={nextCoverage?.name}
        handleBackAction={handleBack}
        handleNextAction={handleNext}
      />
    </>
  );
};

export const EmployeeAssistanceProgramForm = ({ coverage, onFormChange }) => {
  const currentPlan = coverage.details[PLANS][0];

  const handlePlanFormChange = ({ name, value }) => {
    const localPlan = {
      ...currentPlan,
      [name]: value,
      displayName: NO_PLAN,
    };
    const payload = {
      ...coverage,
      details: { ...coverage.details, [PLANS]: [localPlan] },
    };

    onFormChange(payload, 0, name);
  };

  return (
    <CommentsField
      currentPlan={currentPlan}
      onChange={(e) => {
        handlePlanFormChange(e.target);
      }}
    />
  );
};

export default EmployeeAssistanceProgram;
